<ion-header>
  <ion-toolbar>
    <ion-title class="tw-uppercase tw-text-center">place wager</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="dutch-modal-container">

  <div class="
    race-pool tw-mt-[19px] tw-border-b tw-border-[#2F80EC] tw-pb-[5px]
  ">
    <span class="tw-block tw-uppercase tw-font-bold tw-text-[19px] tw-text-[#000000]">
      {{eventName}}
    </span>
    <span class="
      tw-uppercase tw-font-bold tw-text-[19px] tw-text-[#000000]
    ">
      race {{dutchTicket?.RaceId}}
    </span>
    <span class="
      tw-uppercase tw-font-bold tw-text-[19px] tw-text-[#000000]
    ">
      {{pool?.PoolId}}

      {{
        modifier !== undefined ?
        modifier === 'DutchCost' ?
          'DC' : modifier : ''
      }}

      {{selectedRunners}}
    </span>
  </div>

  <div class="current-roi tw-border-b tw-border-[#6C6C6C] tw-pt-[13px]">
    <span class="tw-font-bold tw-text-[16px] tw-text-[#2F80EC]">
      Current ROI  {{minPayout}}%  {{maxPayout}}%
    </span>
  </div>

  <div class="current-bets">
    <div
      *ngFor="let item of dutchTicket.Wagers; index as i"
      class="clear-both tw-border-b tw-border-[#8B8B8B] tw-py-[2px]"
    >
      <div class="amount1 tw-float-left">
        <span class="tw-font-bold tw-text-[12px] tw-text-[#000000]">
          ${{item?.BaseAmount}}
        </span>
      </div>
      <div class="amount-percent tw-float-left">
        <span class="tw-font-bold tw-text-[12px] tw-text-[#000000]">
          {{item?.getWagerString()[2]}}
        </span>
      </div>
      <div class="amount2 tw-float-left">
        <span class="tw-font-bold tw-text-[12px] tw-text-[#000000]">
          ${{dutchAmountHolder[i][1]}}
        </span>
      </div>
      <div class="no-valid-wager tw-float-left">
        <span class="tw-text-[13px] tw-text-[#FF0000]">
          {{item?.Error}}
        </span>
      </div>
      <div class="trash-action tw-float-right tw-mr-[20px]">
        <img
          (click)="removeBet(i)"
          src="/assets/images/account_settings/trash_icon_light.svg"
          class="l-mode tw-z-50 tw-relative tw-top-[4px] tw-float-right"
          alt="trash icon"
        >
        <img
          (click)="removeBet(i)"
          src="/assets/images/account_settings/trash_icon_dark.svg"
          class="d-mode tw-z-50 tw-relative tw-top-[4px] tw-float-right"
          alt="trash icon"
        >
      </div>
    </div>
  </div>

  <div class="tw-mt-[30px]">
    <span class="total-cost tw-font-bold tw-text-[16px] tw-text-[#000000]">
      Total Cost: <span class="tw-text-[16px] tw-text-[#7C7C7C]">${{totalCost | number:'1.2'}}</span>
    </span>
  </div>

  <ion-grid class="submit-save-close-btns tw-mt-[50px] tw-pr-[0] tw-pl-[0]">
    <ion-row>
      <ion-col class="tw-pl-[0]">
        <ion-button (click)="submitAll()" class="confirm-btn">
          submit
        </ion-button>
      </ion-col>
      <ion-col class="tw-text-center">
        <ion-button (click)="saveAll()" class="confirm-btn">
          save
        </ion-button>
      </ion-col>
      <ion-col class="tw-text-right tw-pr-[0]">
        <ion-button (click)="close()" class="confirm-btn">
          close
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>

</ion-content>
